import type { CuratedItem, InfoDataMap } from "~types/types";

const LABEL_DEFAULTS = {
    eyebrowData: {
        name: null,
        url: null,
        disableEyebrow: false,
    },
};

const LABEL_INFO: InfoDataMap = {
    "ESG & Investing": {
        eyebrowData: {
            name: "ESG",
            url: "/green/esg-investing",
        },
    },
    AI: {
        eyebrowData: {
            name: "AI",
            url: "/technology-ai",
        },
    },
    Business: {
        eyebrowData: {
            url: "/opinion-business",
        },
    },
    Finance: {
        eyebrowData: {
            url: "/opinion-finance",
        },
    },
    Economics: {
        eyebrowData: {
            url: "/opinion-economics",
        },
    },
    Markets: {
        eyebrowData: {
            url: "/opinion-markets",
        },
    },
    "Politics & Policy": {
        eyebrowData: {
            url: "/opinion-politics-and-policy",
        },
    },
    "Technology & Ideas": {
        eyebrowData: {
            url: "/opinion-technology-and-ideas",
        },
    },
    Design: {
        eyebrowData: {
            url: "/citylab/design",
        },
    },
    Culture: {
        eyebrowData: {
            url: "/citylab/culture",
        },
    },
    Transportation: {
        eyebrowData: {
            url: "/citylab/transportation",
        },
    },
    Environment: {
        eyebrowData: {
            url: "/citylab/environment",
        },
    },
    Economy: {
        eyebrowData: {
            url: "/citylab/economy",
        },
    },
    Housing: {
        eyebrowData: {
            url: "/citylab/housing",
        },
    },
    Justice: {
        eyebrowData: {
            url: "/citylab/justice",
        },
    },
    Government: {
        eyebrowData: {
            url: "/citylab/government",
        },
    },
    Technology: {
        eyebrowData: {
            url: "/citylab/technology",
        },
    },
};

export function getLabelEyebrowData(item: CuratedItem) {
    const label = item.label ?? "";
    const info = LABEL_INFO[label] || {};

    return { ...LABEL_DEFAULTS.eyebrowData, ...info.eyebrowData };
}
